import { WALLET_WARNING_RULES } from '@modules/consolidator/constants/wallet-warning-rules'

export const resolveWalletWarning = (rawWarning) => {
  const text =
    typeof rawWarning === 'string'
      ? rawWarning
      : (rawWarning && rawWarning.message) || ''
  if (!text) return { text: '', action: null, actionLabel: '' }

  const rule = WALLET_WARNING_RULES.find((item) => text.includes(item.match))
  if (!rule) return { text, action: null, actionLabel: '' }

  return {
    text: rule.message,
    action: rule.action,
    actionLabel: rule.actionLabel,
  }
}
